import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
// import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { NewModel } from '../../../model/new';
import TimelineNews from '../Home/TimelineNews';

// eslint-disable-next-line import/no-cycle
import {
  // StyledTraffic,
  // StyledWeather,
  StyledNewsTab
} from '../LayoutElectron/home/style';
import {
  StyledBoxMain,
  StyledColumnLeft,
  StyledBoxInside,
  StyledNotification
} from '../Home/style';
import { StyledButtonUpdate, StyledNewsWidget } from './style';

import {
  loadNews,
  loadNewsHighlight,
  loadNewsSticky,
  getNews
} from '../../../actions';
// import { StyledButton } from '../Header/style';

const NewsWidget = ({
  user,
  className,
  // notifications,
  dispatchloadNewsHighlights,
  dispatchloadNewsSticky,
  dispatchGetNews
}) => {
  const [newsState, setNewsState] = useState();
  const [newsHiglightState, setNewsHiglightState] = useState();
  const [newsStickyState, setNewsStickyState] = useState();
  const [refresh, setRefresh] = useState(false);
  const updateNews = () => {
    setNewsState('');
    setNewsStickyState('');
    setNewsHiglightState('');
    dispatchloadNewsHighlights().then(res => setNewsHiglightState(res));
    dispatchloadNewsSticky().then(res => setNewsStickyState(res));
    dispatchGetNews().then(res => setNewsState(res.content));
  };
  useEffect(() => {
    dispatchloadNewsHighlights().then(res => setNewsHiglightState(res));
    dispatchloadNewsSticky().then(res => setNewsStickyState(res));
    dispatchGetNews().then(res => setNewsState(res.content));
  }, []);

  useEffect(() => {
    updateNews();
  }, [refresh]);

  setTimeout(() => {
    setRefresh(!refresh);
  }, 300000);

  return (
    <StyledNewsWidget className={className}>
      <StyledNotification show={false} />
      <p className="NewsWidget-name">Hola {user}!</p>
      <StyledButtonUpdate onClick={() => updateNews()}>
        Actualizar Noticias
      </StyledButtonUpdate>
      <StyledBoxMain tabs={0} className="boxWidget">
        <StyledBoxInside>
          <StyledColumnLeft>
            {newsHiglightState?.length > 0 && (
              <StyledNewsTab
                key={newsHiglightState[0].id}
                {...newsHiglightState[0]}
                orientation="horizontal"
                isWidget
              />
            )}
            {newsStickyState?.length > 0 &&
              newsStickyState?.map(item => (
                <StyledNewsTab
                  key={item.id}
                  {...item}
                  orientation="horizontal"
                  isWidget
                />
              ))}
            {newsState?.length > 0 &&
              newsState?.map(item => (
                <StyledNewsTab
                  key={item.id}
                  {...item}
                  orientation="horizontal"
                  isWidget
                />
              ))}
          </StyledColumnLeft>
        </StyledBoxInside>
      </StyledBoxMain>
    </StyledNewsWidget>
  );
};

NewsWidget.propTypes = {
  news: PropTypes.arrayOf(NewModel),
  newsHighlight: PropTypes.arrayOf(NewModel),
  newsSticky: PropTypes.arrayOf(NewModel),
  currentPage: PropTypes.number,
  loadMore: PropTypes.func,
  total: PropTypes.number,
  user: PropTypes.string,
  notifications: PropTypes.arrayOf()
};

TimelineNews.defaultProps = {
  news: [],
  newsHighlight: [],
  newsSticky: []
};

const mapStateToProps = state => ({
  news: state.news,
  newsHighlight: state.news.newsHighlight,
  newsSticky: state.news.newsSticky,
  user: state.user.user.name,
  notifications: state.notifications.notificationsList
});

const mapDispatchToProps = dispatch => ({
  dispatchloadNewsHighlights: () => dispatch(loadNewsHighlight()),
  dispatchloadNewsSticky: () => dispatch(loadNewsSticky()),
  dispatchloadNews: () => dispatch(loadNews()),
  dispatchGetNews: () => dispatch(getNews())
});

export default connect(mapStateToProps, mapDispatchToProps)(NewsWidget);
